<script>
    import { getProfileAction } from '../domain/session/profile.actions';
    import { useNavigate } from 'svelte-navigator';
    import { slide } from 'svelte/transition';
    import ButtonBase from 'common/ButtonBase.svelte';
    import Icon from 'components/Icon.svelte';
    import session from 'store/session';
    import userStore from 'store/user';
    import pubsub from 'sweet-pubsub';
    import reciever from '../store/reciever';
    import { onMount } from 'svelte';
    import sessionStore from 'store/session';

    let navigate = useNavigate();

    let selected = '';
    let numbers = [];

    const onChangeSec = number => {
        if (!number) {
            return
        }
        selected = number.business_number?.phone_number;
        reciever.set(number)
    }

    const onContinue = () => {
        let selected_object = numbers.find(
            ({business_number}) => business_number.phone_number === selected
        );

        const { business_number, id, balance } = selected_object
        const { phone_number, id: business_number_id } = business_number

        userStore.setMobile(phone_number);
        userStore.setMobileID(business_number_id);
        userStore.setReceiverID(id);

        session.setBalance(balance);
        pubsub.emit('number_selected', business_number);

        navigate('/');
    };

    onMount(async () => {
        sessionStore.subscribe(({receivers}) => {
            numbers = receivers
        });
        
        if (numbers && numbers.length === 0) {
            await getProfileAction()
            sessionStore.subscribe(({receivers}) => {
                numbers = receivers
            });
        }
    })

</script>

<div id="choose-number" class="row content">
    <section class="display-flex">
        <div class="logo"><Icon icon="logo" size="64" /></div>

        <div class="heading">Choose a Number to Continue</div>

        <div class="choose-number-list">
            {#if numbers && numbers.length > 0}
                {#each numbers as number (number)}
                    <div
                        class="number-item"
                        class:active={selected == number.business_number?.phone_number}
                        in:slide={{ duration: 1000 }}
                    >
                        <label for="phone-number-1">{number.business_number?.phone_number}</label>
                        <input
                            id="phone-number-1"
                            type="radio"
                            name="phone-number"
                            bind:group={selected}
                            value={number.business_number?.phone_number}
                            on:change={onChangeSec(number)}
                        />
                    </div>
                {/each}
            {/if}
        </div>

        <ButtonBase on:click={onContinue} disabled={!selected} style="width: 100%;">
            <button class="button">Continue</button>
        </ButtonBase>
    </section>
</div>

<style lang="scss">
    #choose-number {
        section {
            margin: 0 1.25rem;
            max-width: calc(100vw - 1.25rem);
            .logo {
                margin-top: 1rem;
            }
            .heading {
                margin-bottom: 1rem;
                font-family: 'Recoleta';
                font-style: normal;
                font-size: 20px;
                font-weight: 700;
            }
            .button {
                width: 100%;
            }
            .choose-number-list {
                width: 100%;
                height: calc(200px - 32px);
                overflow-y: scroll;
                margin-bottom: 20px;
            }

            .number-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 16px;
                margin-bottom: 10px;
                font-family: 'Urbanist';
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 140%;
                color: #474b50;
                border-radius: 12px;
                background: #ffffff;
                border: 1px solid #eeeeee;
                label {
                    font-family: 'Urbanist';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                }
            }

            .number-item.active {
                background: rgba(207, 235, 246, 0.15);
                border: 1px solid #0e99d2;
                label {
                    font-weight: 700;
                    font-size: 18px;
                }
            }

            .number-item input[type='radio'] {
                width: auto;
            }

            .number-item label {
                width: 100%;
            }

            .choose-number-btn {
                margin: 0.5rem 0;
            }
        }
    }
</style>
